import { type LiftedLinks, prependPathWithParams } from '@dhl/utils'
import { addressBookLinks, type AddressBookLinks } from './addressBook/links.js'
import { preferencesLinks, type PreferencesLinks } from './preferences-legacy/links.js'
import { deliveryPreferenceLinks, type DeliveryPreferencesLinks } from './preferences/links.js'
import { type SettingsLinks, settingsLinks } from './settings/links.js'
import { dhlExtraLinks, type DhlExtraLinks } from './dhl-extra/view/links.js'

export const paths = {
  OVERVIEW: '',
  SETTINGS: 'settings',
  PREFERENCES: 'preferences',
  APPLICATION: 'application',
  EXTRA: 'extra',
  LOG_OUT: 'log-out',
  CONFIRM: 'confirm',
  ADDRESS_BOOK: 'address-book',
  AVATAR: 'avatar',
}

export const profileLinks: ProfileLinks = {
  ...prependPathWithParams(() => paths.SETTINGS, settingsLinks),
  ...prependPathWithParams(() => paths.PREFERENCES, preferencesLinks),
  ...prependPathWithParams(() => paths.PREFERENCES, deliveryPreferenceLinks),
  ...prependPathWithParams(() => paths.ADDRESS_BOOK, addressBookLinks),
  ...prependPathWithParams(() => paths.EXTRA, dhlExtraLinks),
  profileOverviewLink: () => '',
  applicationLink: () => `/${paths.APPLICATION}`,
  settingsLink: () => `/${paths.SETTINGS}`,
  preferencesLink: () => `/${paths.PREFERENCES}`,
  addressBookLink: () => `/${paths.ADDRESS_BOOK}`,
  logOutDialogLink: () => `/${paths.LOG_OUT}`,
  logOutConfirmLink: () => `/${paths.LOG_OUT}/${paths.CONFIRM}`,
  editAvatarLink: () => `/${paths.AVATAR}`,
}

export type ProfileLinks = LiftedLinks<SettingsLinks, unknown, false> &
  LiftedLinks<PreferencesLinks, unknown, false> &
  LiftedLinks<DeliveryPreferencesLinks, unknown, false> &
  LiftedLinks<DhlExtraLinks, unknown, false> &
  LiftedLinks<AddressBookLinks, unknown, false> & {
    profileOverviewLink: () => string
    applicationLink: () => string
    settingsLink: () => string
    preferencesLink: () => string
    addressBookLink: () => string
    logOutDialogLink: () => string
    logOutConfirmLink: () => string
    editAvatarLink: () => string
  }
